export default __webpack_public_path__ + "static/media/deer.695bb296.svg";